import { render, staticRenderFns } from "./SkillsList.vue?vue&type=template&id=05f9779e&"
import script from "./SkillsList.vue?vue&type=script&lang=js&"
export * from "./SkillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports